var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4403 15.4326H12.2509C12.7945 15.4326 13.1884 15.3317 13.4325 15.1299C13.6766 14.9281 13.7987 14.6286 13.7987 14.2314C13.7987 13.8278 13.6669 13.5381 13.4032 13.3623C13.1395 13.1865 12.7424 13.0986 12.2118 13.0986H11.4403V15.4326ZM11.4403 16.3994V19.251H10.2733V12.1123H12.2899C13.2111 12.1123 13.8931 12.2848 14.3358 12.6299C14.7785 12.9749 14.9999 13.4958 14.9999 14.1924C14.9999 15.0811 14.5376 15.7142 13.6132 16.0918L15.6298 19.251H14.3016L12.5927 16.3994H11.4403Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6895 15.6719C22.6895 16.834 22.3981 17.7373 21.8154 18.3818C21.236 19.0264 20.4141 19.3486 19.3496 19.3486C18.2721 19.3486 17.4437 19.0296 16.8643 18.3916C16.2881 17.7503 16 16.8405 16 15.6621C16 14.4837 16.2897 13.5788 16.8692 12.9473C17.4518 12.3158 18.2819 12 19.3594 12C20.4206 12 21.2409 12.3206 21.8203 12.9619C22.3998 13.6032 22.6895 14.5065 22.6895 15.6719ZM17.2402 15.6719C17.2402 16.5508 17.4177 17.2181 17.7725 17.6738C18.1273 18.1263 18.653 18.3525 19.3496 18.3525C20.043 18.3525 20.5654 18.1279 20.917 17.6787C21.2718 17.2295 21.4492 16.5605 21.4492 15.6719C21.4492 14.7962 21.2734 14.1322 20.9219 13.6797C20.5736 13.2272 20.0527 13.001 19.3594 13.001C18.6595 13.001 18.1305 13.2272 17.7725 13.6797C17.4177 14.1322 17.2402 14.7962 17.2402 15.6719Z",
    fill: "#161616"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.71d0b56e92035136c78d2e5305f5bb60.svg";
export { ForwardRef as ReactComponent };